export default {
    HOME: 'Home',
    ABOUT: 'About',
    CONTACTUS: 'Contact US',
    SERVICES: 'Services',
    SETTINGS: 'Settings',
    THEME: 'Theme'
}